import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: paths.map(i => (
    {
      path: '/' + i.replace('home.vue', '').replace('.vue',''),
      name: i.replace('.vue',''),
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../Vue-CMS-Data/views/' + i)
    }
  ))})
